import React, { Component } from 'react'
import { TextAreaStyle } from './style'
export class TextArea extends Component {
  
  render () {
    const {
      placeholder,
      value,
      onChange,
      className = '',
      type,
      disabled,
      handleEditModal,
      isEditable
    } = this.props
    const defaultFunction = () => {}
    return (
      <TextAreaStyle>
        <div className={`${disabled ? 'handleEditModal' : ''}`} onClick={() => (handleEditModal && !isEditable ? handleEditModal() : defaultFunction())}>
        <textarea
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`textarea-field ${className} ${disabled ? 'disabled' : ''}`}
          type={type || 'text'}
          disabled={disabled}
          />
        </div>
      </TextAreaStyle>
    )
  }
}
